"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var appBarBaseTheme = function (breakpoints) {
    var _a, _b, _c, _d, _e, _f, _g;
    var MAX_S = breakpoints.MAX_S, MIN_S = breakpoints.MIN_S, MIN_L = breakpoints.MIN_L, MAX_L = breakpoints.MAX_L;
    return ({
        appBarProps: {
            color: "inherit",
            position: "relative"
        },
        appBar: {
            order: 1,
            padding: 0
        },
        appBarNavPopoverWrapper: (_a = {
                flex: 1,
                display: "flex",
                justifyContent: "flex-end"
            },
            _a[MAX_S] = {
                display: "none",
            },
            _a),
        appBarNavPopover: {
            flex: 1,
            display: "flex",
            flexDirection: "row-reverse",
        },
        appBarDrawerButton: (_b = {
                marginBottom: "5px"
            },
            _b[MIN_L] = {
                display: "none",
            },
            _b[MAX_S] = {
                marginBottom: "0px",
            },
            _b),
        appBarDrawerButtonIcon: {
            name: "menu"
        },
        appBarHome: (_c = {
                display: "flex",
                justifyItems: "center"
            },
            _c[MAX_S] = {
                justifyContent: "center",
            },
            _c[MAX_L] = {
                flex: 1
            },
            _c),
        appBarImage: {
            //content: "url(https://easydita.com/wp-content/uploads/2018/12/easyDITA-and-Jorsek-Logo-Small.png)",
            height: "1.5rem"
        },
        appBarDrawerAccordionWrapper: {
            paddingTop: "0",
            paddingBottom: "0"
        },
        appBarDrawerHome: {
            display: "flex",
            alignItems: "center",
            height: "3rem",
            paddingLeft: "1.5rem",
            fontWeight: 800,
            alignContent: "center"
        },
        appBarDrawerHomeImage: {
            height: "1.5rem",
            width: "auto"
        },
        appBarDrawerHeader: {
            display: "flex",
            justifyContent: "space-between",
            paddingLeft: "0.5rem",
            "& img": {
                height: "50px",
                marginTop: "10px",
                marginBottom: "10px",
            }
        },
        appBarDrawerCloseIcon: {},
        appBarDrawerPaper: {
            minWidth: "280px"
        },
        appBarSearchIcon: (_d = {
                name: 'search',
                close: 'close',
                "& .material-icons": {
                    marginTop: "9px",
                    height: "auto",
                    width: "27px",
                }
            },
            _d[MAX_S] = {
                marginRight: "1rem",
            },
            _d[MIN_S] = {
                display: "none !important",
            },
            _d),
        appBarToolbar: {
            height: "100%",
            width: "100%",
            flex: 1
        },
        appBarSearchCollapse: (_e = {
                transform: "translate(100vw,0) !important"
            },
            _e[MIN_S] = {
                transform: "initial !important"
            },
            _e),
        appBarSearchBoxIcon: {},
        appBarSearchBox: (_f = {
                icon: 'search',
                width: "calc(100vw - 2rem)",
                alignSelf: "center",
                marginBottom: "0.25rem"
            },
            _f[MIN_S] = {
                width: "100%",
                height: "100%",
                alignSelf: "center",
                marginBottom: "0",
                display: "flex"
            },
            _f),
        appBarSearchWrapper: (_g = {
                transform: "translate(1,0)",
                transition: "0.2s all ease-in-out",
                position: "fixed",
                top: "3.5rem",
                left: "1rem"
            },
            _g[MIN_S] = {
                height: "2.25rem",
                width: "30rem",
                display: "flex",
                transform: "initial",
                transition: "initial",
                position: "initial",
                top: "initial",
            },
            _g),
    });
};
exports.default = appBarBaseTheme;
//# sourceMappingURL=appBar.js.map